import {apiDelete, apiGet, apiPost, apiPut} from "./api";

export interface HealthConditionMaster {
    Code: string;
    Name: string;
    CreatedDate: number;
    LastModifiedDate: number;
}

export interface HealthConditionMasterSearchParams {
    Code?: string;
    Name?: string;
}

export interface HealthConditionMasterInput {
    Code: string;
    Name: string;
}

export const getHealthConditionMasters = async (
    params: HealthConditionMasterSearchParams = {},
    targetOrg?: string
): Promise<HealthConditionMaster[]> => {
    return await apiGet(`/health-condition-master${targetOrg ? '?targetOrg=' + targetOrg : ''}`, {
        code: params.Code,
        name: params.Name
    });
};

export const createHealthConditionMaster = async (
    data: HealthConditionMasterInput,
    targetOrg?: string
): Promise<HealthConditionMaster> => {
    return await apiPost(`/health-condition-master${targetOrg ? '?targetOrg=' + targetOrg : ''}`, data);
};

export const updateHealthConditionMaster = async (
    previousCode: string,
    data: HealthConditionMasterInput,
    targetOrg?: string
): Promise<HealthConditionMaster> => {
    return await apiPut(`/health-condition-master${targetOrg ? '?targetOrg=' + targetOrg : ''}`, {
        ...data,
        PreviousCode: previousCode
    });
};

export const deleteHealthConditionMaster = async (code: string, targetOrg?: string): Promise<void> => {
    await apiDelete(`/health-condition-master${targetOrg ? '?targetOrg=' + targetOrg : ''}`, {Code: code});
};
